module.exports = __webpack_public_path__ + "static/media/menu_border.a7bb793a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu_border.svg
// module id = 102
// module chunks = 0